import R from 'ramda'

const INSTAGRAM_COMMENT_REPLY_DISPLAY_TYPE = 'Send Instagram Comment Reply'
const INSTAGRAM_COMMENT_REPLY_WIDGET_TYPE = 'SEND_INSTAGRAM_COMMENT_REPLY'

const hasText = R.pathSatisfies(R.complement(R.isNil), ['message', 'message'])
const hasWidgetType = R.propEq('type', INSTAGRAM_COMMENT_REPLY_WIDGET_TYPE)
const isCommentReplyWidgetAction = R.both(hasText, hasWidgetType)

const convertInstagramCommentToFormComment = R.applySpec({
  type: R.always(INSTAGRAM_COMMENT_REPLY_DISPLAY_TYPE),
  igCommentReplyMessage: R.path(['message', 'message'])
})

export { isCommentReplyWidgetAction, convertInstagramCommentToFormComment }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/instagram/widget-to-form/instagram-comment-reply.js